import Vue from "vue";
import Router from "vue-router";
import request from "@/axios.js";

import VueCookies from "vue-cookies";
//import store from "./store/store";

Vue.use(Router);

let router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	scrollBehavior() {
		return {x: 0, y: 0};
	},
	routes: [
		{
			/*
			 * =============================================================================
			 * MAIN LAYOUT ROUTES
			 * =============================================================================
			 */
			path: "",
			component: () => import("./layouts/main/Main.vue"),
			children: [
				/*
				 * =============================================================================
				 * Theme Routes
				 * =============================================================================
				 */
				{
					path: "/",
					name: "home",
					component: () => import("@/views/dashboard/Home.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/leave-us-a-message",
					name: "contactform",
					component: () => import("@/components/forms/contact/ContactForm.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/documents",
					name: "documents",
					component: () => import("@/views/dashboard/Documents.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/society",
					name: "society",
					component: () => import("@/views/dashboard/Society.vue"),
					meta: {
						requiresAuth: true,
						rule: "financecommercial"}
				},
				{
					path: "/contracts",
					name: "contracts",
					component: () => import("@/views/dashboard/Contracts.vue"),
					meta: {
						requiresAuth: true,
						rule: "financecommercial"}
				},
				{
					path: "/consultants",
					name: "consultants",
					component: () => import("@/views/dashboard/Consultants.vue"),
					meta: {
						requiresAuth: true,
						rule: "externcollaborator"}
				},
				{
					path: "/prospects",
					name: "prospects",
					component: () => import("@/views/dashboard/ProspectsV2.vue"),
					meta: {
						requiresAuth: true,
						rule: "commercial"}
				},
				{
					path: "/prospectsProject/details/:ppId?",
					name: "prospectsProjectDetails",
					component: () => import("@/views/pages/prospection/ProspectProjectDetails.vue"),
					meta: {
						requiresAuth: true,
						rule: "commercial"}
				},
				{
					path: "/tasks",
					name: "tasks",
					component: () => import("@/views/dashboard/Tasks.vue"),
					meta: {
						requiresAuth: true,
						rule: "externcollaborator"}
				},
				{
					path: "/netlink",
					name: "netlink",
					component: () => import("@/views/dashboard/Netlink.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/backlinks-repertoire",
					name: "backlinks-repertoire",
					component: () => import("@/views/dashboard/Backlinks.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/backlinks-repertoire/:thematic",
					name: "backlinks-repertoire-results",
					component: () => import("@/views/dashboard/Backlinks.vue"),
					props: true,
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/backlinks-listes",
					name: "backlinks-lists",
					component: () => import("@/views/dashboard/BacklinksLists.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/backlinks-details/:id",
					name: "backlinks-details",
					component: () => import("@/views/dashboard/BacklinksDetails.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/netlink-thema",
					name: "netlink-thema",
					component: () => import("@/views/dashboard/NetlinkThema.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"}
				},
				{
					path: "/dns",
					name: "dns",
					component: () => import("@/views/dashboard/Dns.vue"),
					meta: {
						requiresAuth: true,
						rule: "accountmanager"}
				},
				{
					path: "/providers",
					name: "providers",
					component: () => import("@/views/dashboard/Providers.vue"),
					meta: {
						requiresAuth: true,
						rule: "accountmanager"}
				},
				{
					path: "/purchases",
					name: "purchases",
					component: () => import("@/views/dashboard/Purchases.vue"),
					meta: {
						requiresAuth: true,
						rule: "financeaccountmanager"}
				},
				{
					path: "/invoices",
					name: "invoices",
					component: () => import("@/views/dashboard/Invoices.vue"),
					meta: {
						requiresAuth: true,
						rule: "sadmin"}
				},
				{
					path: "/report",
					name: "report",
					component: () => import("@/views/dashboard/Reports.vue"),
					meta: {
						requiresAuth: true,
						rule: "sadmin"}
				},
				{
					path: "/products",
					name: "products",
					component: () => import("@/views/dashboard/Products.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/netlink_types",
					name: "netlink_types",
					component: () => import("@/views/dashboard/NetlinkTypes.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/collaborator",
					name: "collaborator",
					component: () => import("@/views/dashboard/Collaborator.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/contacts",
					name: "contact",
					component: () => import("@/views/dashboard/Contacts.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/generateTemplateSeo",
					name: "generateTemplateSeo",
					component: () => import("@/views/dashboard/SeoTemplateGeneration.vue"),
					meta: {
						requiresAuth: true,
						rule: "externcollaborator"}
				},
				{
					path: "/logs",
					name: "logs",
					component: () => import("@/views/dashboard/Logs.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/api_costs",
					name: "apiCosts",
					component: () => import("@/views/dashboard/ApiCosts.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/prospects_settings",
					name: "Prospection",
					component: () => import("@/views/dashboard/ProspectsSettings.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/exports",
					name: "exports",
					component: () => import("@/views/dashboard/Exports.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/profile",
					name: "profile",
					component: () => import("@/views/userSettings/Profile.vue"),
					meta: {
						requiresAuth: true,
						rule: "commercial"
					}
				},
				{
					path: "/keyword",
					name: "keyword",
					component: () => import("@/views/statistics/Keywords.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"
					}
				},
				{
					path: "/exploration",
					name: "exploration",
					component: () => import("@/views/statistics/Exploration.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"
					}
				},
				{
					path: "/pagespeed",
					name: "pagespeed",
					component: () => import("@/views/statistics/Pagespeed.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"
					}
				},
				{
					path: "/analyse_semantique",
					name: "analyse_semantique",
					component: () => import("@/views/statistics/Semantic.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"
					}
				},
				{
					path: "/performance",
					name: "performance",
					component: () => import("@/views/statistics/Performance.vue"),
					meta: {
						requiresAuth: true,
						rule: "clientdash"
					}
				},
				{
					path: "/recurring_purchase_check",
					name: "recurring_purchase_check",
					component: () => import("@/views/dashboard/CheckRecurringPurchases.vue"),
					meta: {
						requiresAuth: true,
						rule: "accountmanager"
					}
				},
				{
					path: "/import_netlinks/:fromBdd?",
					name: "import_netlinks",
					component: () => import("@/components/forms/netlink/ImportNetlinks.vue"),
					meta: {
						requiresAuth: true,
						rule: "accountmanager"
					}
				},
				/*
				 * =============================================================================
				 * FORM PAGE LAYOUTS
				 * =============================================================================
				 */
				{
					path: "/entity/new",
					name: "new_entity",
					component: () => import("@/views/forms/NewEntity"),
					meta: {
						requiresAuth: true,
						rule: "financecommercial"
					}
				},
				{
					path: "/entity/update",
					name: "update_entity",
					component: () => import("@/views/forms/UpdateEntity"),
					meta: {
						requiresAuth: true,
						rule: "financecommercial"
					}
				},
				{
					path: "/test",
					name: "test",
					component: () => import("@/views/dashboard/Test.vue"),
					meta: {
						requiresAuth: true,
						rule: "admin"}
				},
				{
					path: "/null",
					name: "return_page",
					component: () => import("@/views/forms/ReturnPage"),
					meta: {
						requiresAuth: true,
						rule: "financecommercial"
					}
				},
			]
		},
		/*
		 * =============================================================================
		 * FULL PAGE LAYOUTS
		 * =============================================================================
		 */
		{
			path: "",
			component: () => import("@/layouts/full-page/FullPage.vue"),
			/*
			 * meta: {
			 *   requiresAuth: false,
			 *   rule: "client"
			 * },
			 */
			children: [
				/*
				 * =============================================================================
				 * PAGES
				 * =============================================================================
				 */
				{
					path: "/login",
					name: "login",
					component: () => import("@/views/pages/Login.vue"),
					meta: {
						requiresAuth: false,
						rule: "client"
					}
				},
				{
					path: "/resetpassword",
					name: "forgottenpassword",
					component: () => import("@/views/pages/ForgottenPassword.vue"),
					meta: {
						requiresAuth: false,
						rule: "client"
					}
				},
				{
					path: "/register",
					name: "register",
					component: () => import("@/views/pages/Register.vue"),
					meta: {
						requiresAuth: false,
						rule: "client"
					}
				},
				{
					path: "/error-404",
					name: "error-404",
					component: () => import("@/views/pages/Error404.vue"),
					meta: {
						requiresAuth: true,
						rule: "client"
					}
				},

				//  EXTRANAL PAGES
				{
					path: "/notes-seo",
					name: "noteseo",
					component: () => import("@/views/dashboard/Test.vue"),
					meta: {
						requiresAuth: false,
						rule: "client"
					}
				}
			]
		},
		// Redirect to 404 page, if no match found
		{
			path: "*",
			redirect: "/error-404"
		}
	]
});

/*
 * router.onReady(() => {
 *   store.commit("isAuthenticated");
 * });
 * Locking route for user that aren't logged in
 */
router.beforeEach((to, from, next) => {
	console.log(`[Router] Navigating from "${from.fullPath}" to "${to.fullPath}"`);

	// Auth-required route
	if (to.matched.some(record => record.meta.requiresAuth)) {
		const nid = VueCookies.get("nid");
		const kb = VueCookies.get("kb");

		// Not logged in → redirect to login
		if (!nid) {
			console.warn("[Router] Not authenticated, redirecting to /login");
			return next({
				path: "/login",
				params: { nextUrl: to.fullPath }
			});
		}

		// Get user role
		const userInfo = VueCookies.isKey("userInfo") ? VueCookies.get("userInfo") : null;
		const userRole = userInfo ? userInfo["userRole"] : "210";

		// Auth check via backend
		request
			.post("users/pch", {
				nid,
				kb,
				userRole,
				ip: ""
			})
			.then(res => {
				if (!res.data.permission) {
					console.warn("[Router] Permission denied, logging out");
					VueCookies.remove("nid");
					VueCookies.remove("kb");
					VueCookies.remove("aspi");
					VueCookies.remove("userInfo");
					next({ path: "/login" });
				} else {
					console.log("[Router] Permission granted");
					next(); // ✅ proceed
				}
			})
			.catch(err => {
				console.error("[Router] Auth check failed:", err);
				// 🔒 Cancel navigation to avoid broken state
				next(false);
			});
	}

	// Public route
	else {
		// Already logged in → redirect to home if trying to access login/register/etc.
		if (VueCookies.get("nid")) {
			console.log("[Router] Already logged in, redirecting to home");
			next({ path: "/" });
		} else {
			next(); // ✅ proceed
		}
	}
});


router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById("loading-bg");
	if(appLoading) {
		appLoading.style.display = "none";
	}
});

export default router;
